import { ViewWithLoader } from "@/components/v2/ViewWithLoader";
import { LibraryPageContext } from "@/pages/library_v2/components/filesView/context";
import { useTrans } from "@/translations";

import { useContext } from "react";

import { FileListTableRow } from "./fileRow";
import { TABLE_ROW_HEIGHT_PX, TABLE_VISIBLE_ROWS } from "./tableHeaders";

export const FileListTableView: React.FC = () => {
  const { t } = useTrans();
  const { displayedFiles, isFetchingFiles } = useContext(LibraryPageContext);

  if (!displayedFiles.length) {
    return (
      <div className="px-5 py-[52px] text-center text-[14px] text-[#9a958f]">
        {t("libraryPage:fileListNoFilesMessage")}
      </div>
    );
  }

  return (
    <ViewWithLoader isLoading={isFetchingFiles}>
      <div
        style={{ maxHeight: TABLE_ROW_HEIGHT_PX * TABLE_VISIBLE_ROWS }}
        className="overflow-y-auto"
      >
        {displayedFiles.map((f, index) => (
          <FileListTableRow key={f.id} file={f} isFirstRow={index === 0} />
        ))}
      </div>
    </ViewWithLoader>
  );
};
